import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import { rootCatchError } from '../../../lib/Utils'
import * as actions from '../actions'

export const getPaidAdsObservable = ([action, state]) => {
  const {
    retailerIds,
    brandId,
    fields,
    filter,
    offset,
    page_size,
    sort,
  } = action.payload
  const jwt = jwtSelector(state) || action.payload.jwt

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!retailerIds && !brandId) {
    throw new Error('At least 1 retailer or brand ID required')
  }

  if (retailerIds && brandId) {
    throw new Error(
      'Must pass *only* a collection of retailer IDs OR a brand ID',
    )
  }

  // Not supported in query-string 5.1.1
  // const params = queryString.stringify({ retailer_id: retailerIds, fields }, { arrayFormat: 'comma' })

  let paramsList = []

  if (retailerIds) {
    paramsList.push(`retailer_id=${retailerIds.join(',')}`)
  } else if (brandId) {
    paramsList.push(`brand_id=${brandId}`)
  }
  if (offset) {
    paramsList.push(`offset=${offset}`)
  }
  if (page_size) {
    paramsList.push(`page_size=${page_size}`)
  }
  if (sort) {
    paramsList.push(`sort=${sort}`)
  }
  if (filter) {
    paramsList.push(`filter=${filter}`)
  }
  if (fields) {
    paramsList.push(`fields=${fields.join(',')}`)
  }

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers: {
      Authorization: jwt,
    },
    url: `${Config.SERVICE_BASE}/ad/v1/campaign?${paramsList.join('&')}`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.GET_PAID_ADS_FULFILLED,
        payload: payload.response,
        meta: action.payload,
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_PAID_ADS_REJECTED,
        payload: {
          response: payload.response,
          status: payload.status,
          retryPayload: {
            type: actions.GET_PAID_ADS,
            payload: action.payload,
          },
        },
        meta: action.payload,
      })
    }),
  )
}

export const getPaidAdsEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_PAID_ADS),
    withLatestFrom(state$),
    mergeMap(getPaidAdsObservable),
    rootCatchError(actions.GET_PAID_ADS_REJECTED),
  )
}
